import React, { useState, useEffect } from 'react';
import { getAllJokesFromStorage } from '../utils/persistenceUtils';
import { useResponsive } from '../hooks/useResponsive';

interface JokeViewerProps {
  isOpen: boolean;
  onClose: () => void;
}

interface TowerJokes {
  towerId: string;
  jokes: string[];
}

const JokeViewer: React.FC<JokeViewerProps> = ({ isOpen, onClose }) => {
  const [allJokes, setAllJokes] = useState<TowerJokes[]>([]);
  const { isMobile } = useResponsive();
  
  useEffect(() => {
    if (isOpen) {
      // Load all jokes when the viewer is opened
      const jokesObj = getAllJokesFromStorage();
      
      // Convert to array for easier rendering
      const jokesArray = Object.entries(jokesObj).map(([towerId, jokes]) => ({
        towerId,
        jokes
      }));
      
      setAllJokes(jokesArray);
    }
  }, [isOpen]);
  
  if (!isOpen) return null;
  
  return (
    <div style={{
      position: 'fixed',
      top: 0,
      left: 0,
      width: '100%',
      height: '100%',
      backgroundColor: 'rgba(0, 0, 0, 0.8)',
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      justifyContent: 'center',
      zIndex: 1000,
      padding: isMobile ? '10px' : '20px',
      pointerEvents: 'auto'
    }}>
      <div style={{
        backgroundColor: 'white',
        borderRadius: '10px',
        padding: isMobile ? '15px' : '20px',
        width: isMobile ? '90%' : '60%',
        maxWidth: '800px',
        maxHeight: '80vh',
        overflowY: 'auto',
        pointerEvents: 'auto'
      }}>
        <h2 style={{ 
          textAlign: 'center', 
          color: '#9932cc', // Purple for drama
          fontSize: isMobile ? '18px' : '24px',
          marginBottom: '15px'
        }}>
          All Saved Jokes
        </h2>
        
        {allJokes.length === 0 ? (
          <p style={{ textAlign: 'center', padding: '20px' }}>
            No jokes have been saved yet. Create drama towers and add jokes to see them here!
          </p>
        ) : (
          <div style={{ 
            marginBottom: '20px',
            padding: '15px',
            backgroundColor: '#f8f8f8',
            borderRadius: '8px'
          }}>
            <h3 style={{ 
              color: '#9932cc',
              marginBottom: '10px',
              fontSize: isMobile ? '16px' : '18px'
            }}>
              Saved Jokes
            </h3>
            
            <ul style={{ 
              listStyleType: 'none',
              padding: 0,
              margin: 0
            }}>
              {allJokes.flatMap((towerJokes, towerIndex) => 
                towerJokes.jokes.map((joke, jokeIndex) => (
                  <li 
                    key={`${towerJokes.towerId}-${jokeIndex}`}
                    style={{
                      padding: '10px',
                      marginBottom: '5px',
                      backgroundColor: 'white',
                      border: '1px solid #ddd',
                      borderRadius: '5px'
                    }}
                  >
                    <strong>Joke {jokeIndex + 1}:</strong> {joke}
                  </li>
                ))
              )}
            </ul>
          </div>
        )}
        
        <div style={{ 
          display: 'flex', 
          justifyContent: 'center',
          marginTop: '20px'
        }}>
          <button 
            onClick={(e) => {
              e.stopPropagation();
              onClose();
            }}
            style={{
              padding: '10px 20px',
              backgroundColor: '#9932cc',
              color: 'white',
              border: 'none',
              borderRadius: '5px',
              cursor: 'pointer',
              fontSize: isMobile ? '14px' : '16px',
              pointerEvents: 'auto'
            }}
          >
            Close
          </button>
        </div>
      </div>
    </div>
  );
};

export default JokeViewer; 